import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { accent } from '@/components/feature/solution/theme';

interface StatItem {
  icon: string;
  label: string;
  value: number;
  sub: string;
}

interface PanelItem {
  icon: string;
  label: string;
}

interface ValueItem {
  icon: string;
  title: string;
  desc: string;
}

interface ParkingDataCenterProps {
  data: {
    eyebrow: string;
    title: string;
    subtitle: string;
    stats: StatItem[];
    panelsTitle: string;
    panels: PanelItem[];
    note: string;
    values: ValueItem[];
    highlight: string;
  };
}

export default function ParkingDataCenter({ data }: ParkingDataCenterProps) {
  const a = accent('gold');

  return (
    <section id="data-value" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading eyebrow={data.eyebrow} title={data.title} subtitle={data.subtitle} />

        {/* 政府四价值 */}
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {data.values.map((v, idx) => (
            <Reveal key={v.title} delay={idx * 70}>
              <div className="h-full rounded-2xl border border-background-200 bg-background-100 p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-secondary-300">
                <span className={`w-12 h-12 flex items-center justify-center rounded-xl ${a.iconBox}`}>
                  <i className={`${v.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-5 font-heading font-bold text-foreground-950 text-base">{v.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{v.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}